import { render, staticRenderFns } from "./SaitenAnswerImageArea.vue?vue&type=template&id=1c8335da&scoped=true&"
import script from "./SaitenAnswerImageArea.vue?vue&type=script&lang=ts&"
export * from "./SaitenAnswerImageArea.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenAnswerImageArea.vue?vue&type=style&index=0&id=1c8335da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8335da",
  null
  
)

export default component.exports